module.exports = __webpack_public_path__ + "static/media/03-1.69249059.webp";